import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { SUPPORTED_LANGUAGES } from "./constants/config";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: {
      pt: ["en"],
      fr: ["en"],
      default: ["en"],
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    detection: {
      order: ["sessionStorage", "navigator"],
      caches: ["sessionStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    react: { useSuspense: false },
    returnEmptyString: false,
    returnNull: false,
  });

export default i18n;
